require('./sidebarMenuController');

"use strict";

angular.module('app.mainFrame.sidebarMenu.sidebarMenuDirective', [
    'app.mainFrame.sidebarMenu.sidebarMenuController'
])
    .directive('sidebarMenu', [
        function () {
            return {
                restrict: 'EA',
                templateUrl: 'components/mainFrame/sidebarMenu/sidebarMenuView.html',
                controller: 'app.mainFrame.sidebarMenu.sidebarMenuController',
                link: function (scope, elm, attr) {
                    if (!attr.class) {
                        elm.addClass('sidebar-menu');
                    }
                }
            };
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/mainFrame/sidebarMenu/sidebarMenuDirective.js